import { render, staticRenderFns } from "./MypageReviewList.vue?vue&type=template&id=e8c09ab2&"
import script from "./MypageReviewList.vue?vue&type=script&lang=js&"
export * from "./MypageReviewList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports